export default function () {
    this.opts.onClick = {
        close: true,
        preventDefault: false,
        setSelected: true
    };
}
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/wrappers/angular/mmenu.angular.js
// module id = 525
// module chunks = 0